<style lang="scss" scoped>
    #documentApprovalModal .modal-dialog {
        width: 70vw;
        max-width: 1024px;
        padding: 150px 0;
        margin: auto;

        @media (max-width: 1024px) {
            width: 90vw;
        }

        @media (max-width: 767px) {
            width: 100vw;
        }
    }

    .modal-button {
        float: left;
        padding-left: 40px;
        padding-right: 40px;
    }

    .form-check-label {
        font-size: 14px;
    }

    .bold-style {
        font-weight: bold;
    }

    .modal-header {
        display: flex;
        justify-content: space-between;
    }

    .modal-title {
        border: 0;
    }

    .close {
        background: transparent;
        border: 0;
        color: #00A8E1;

        span {
            font-size: 20px;
        }
    }

    .modal-body {
        .container {
            width: 100%;
        }
    }

    .modal-footer {
        width: 100%;
        display: flex;
        justify-content: flex-end;
    }

    ul.collapsible {
        padding: 0;
        margin: 0;
        color: #212121;
        list-style: none;

        &.collapsed {
            li.bar {
                ul.panel {
                    display: none;
                }
            }
        }

        li.bar {
            .title-icon {
                padding: 5px 10px;
                text-decoration: none;
                font-weight: 600;
                display: flex;
                justify-content: space-between;

                i {
                    font-size: 12px;
                }
            }

            ul.panel {
                padding: 0;
                margin-left: 20px !important;
                list-style: none;
                transition-duration: .2s;
                display: block;

                li {
                    padding: 5px 10px;
                    display: flex;
                }
            }
        }
    }

    .generic-collapsible__title,
    .tree-menu__list {
        padding-left: 0;
    }

    .user-groups,
    .document-select {
        padding: 0;
    }

    .user-groups > .modal-body {
        border: 1px solid rgba(34, 36, 38, .15);
        overflow: scroll;
        padding: 15px 15px 15px 0;
        height: 55vh;
        max-height: 55vh;
    }

    .document-select > .container {
        padding: 0;
    }

    .invalid-feedback {
        color: red;
        margin-left: 12px;
        margin-bottom: 6px;
        text-align: left;
        flex: 1;
    }
</style>

<style lang="scss">
    // overwrite standard form input
    .vue-treeselect__input {
        border: 0 !important;
        padding: 0 !important;
    }

    // overwrite standard form input
    .vue-treeselect__input:focus {
        border-color: transparent !important;
        box-shadow: 0 0 black !important;
    }

    .vue-treeselect__control, .vue-treeselect__menu {
        border-radius: 0 !important;
    }
</style>

<template>
    <div class="modal fade" id="documentApprovalModal" tabindex="-1" role="dialog"
         aria-labelledby="documentApprovalModalLabel" aria-hidden="true">
        <div class="modal-dialog" role="document">
            <div class="modal-content">
                <div class="modal-header">
                    <h3 class="modal-title" id="documentApprovalModalLabel">Document Approval Dialog</h3>
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <div class="modal-body">
                    <div class="container">
                        <div class="row">
                            <div class="col-md-4 user-groups">
                                <h4>User groups</h4>
                                <treeSelect :multiple="true"
                                                :options="permissions.userGroups"
                                                placeholder="Select"
                                                v-model="permissions.selectedUsers" />
                            </div>
                            <div class="col-md-8 document-select">
                                <h4>Selected Products</h4>
                                <document-picker/>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="modal-footer">
                    <p v-if="validationError" class="invalid-feedback">Document must belong to at least one user
                        group.</p>
                    <button type="button" class="float-right btn btn-primary modal-button"
                            data-toggle="modal"
                            :data-target="target"
                            @click="handleSubmit">
                        Save
                    </button>
                    <button type="button"
                            class="float-right btn btn-default modal-button"
                            data-dismiss="modal"
                            aria-label="Cancel">
                        Cancel
                    </button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import {mapGetters} from 'vuex'
    import {APPROVE_DOCUMENT, FETCH_TASKS} from "@/store/actions.type";
    import DocumentPicker from "./DocumentPicker";
    import "@riophae/vue-treeselect/dist/vue-treeselect.css"
    import TreeSelect from "@riophae/vue-treeselect";

    export default {
        name: "DocumentApprovalModal",
        components: {
            'document-picker': DocumentPicker,
            TreeSelect
        },
        computed: {
            ...mapGetters("myAdmin", ["taskId", "documentId", "refreshModalToggle", "permissions"]),
            target() {
                if (this.permissions && this.permissions.selectedUsers) {
                    return this.permissions.selectedUsers.length === 0 ? '' : '#documentApprovalModal';
                }
                return '#documentApprovalModal'
            }
        },
        watch: {
            refreshModalToggle: function () {
                this.validationError = false;
            }
        },
        data() {
            return {
                isCollapsed: false,
                validationError: false,
                value: null,
                options: []
            }
        },
        methods: {
            dispatch(action, payload) {
                return this.$store.dispatch('myAdmin/' + action, payload);
            },
            handleSubmit() {
                if (this.permissions.selectedUsers.length === 0) {
                    this.validationError = true;
                } else {
                    this.dispatch(APPROVE_DOCUMENT).then(() => this.dispatch(FETCH_TASKS));
                }
            }
        }
    }
</script>
